import "./WaitlistForm.css";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { FiCheckCircle } from "react-icons/fi";

const FORM_NAME = "bybebek-erken-erisim";

const PACKAGE_OPTIONS = [
  { value: "Mini", label: "Mini" },
  { value: "Plus", label: "Plus" },
  { value: "Pro Mobile", label: "Pro Mobile" },
];

function WaitlistForm({ variant = "default", buttonLabel = "Başvuruyu Gönder" }) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
  });

  const encodeFormData = (data) =>
    new URLSearchParams({
      "form-name": FORM_NAME,
      subject: `${data.firstName} ${data.lastName} erken erişim başvurusu yaptı`,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      preferredPackage: data.preferredPackage,
      fullName: `${data.firstName} ${data.lastName}`,
      "bot-field": "",
    }).toString();

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    setSubmitError("");

    try {
      const response = await fetch("/", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: encodeFormData(data),
      });

      if (!response.ok) {
        throw new Error("Form gönderilemedi.");
      }

      setIsSuccess(true);
      reset();
    } catch (error) {
      setSubmitError(
        "Başvurunuz şu anda gönderilemedi. Lütfen biraz sonra tekrar deneyin."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSuccess) {
    return (
      <div className={`waitlist-form-success waitlist-form-success-${variant}`}>
        <FiCheckCircle />
        <strong>Başvurunuz alındı.</strong>
        <p>Erken erişim süreci başladığında sizinle e-posta üzerinden iletişime geçeceğiz.</p>
      </div>
    );
  }

  return (
    <form
      className={`waitlist-form waitlist-form-${variant}`}
      name={FORM_NAME}
      method="POST"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      onSubmit={handleSubmit(onSubmit)}
      noValidate
    >
      <input type="hidden" name="form-name" value={FORM_NAME} />
      <input type="hidden" name="bot-field" />

      <div className="form-row">
        <label>
          <span>Ad</span>
          <input
            type="text"
            autoComplete="given-name"
            {...register("firstName", {
              required: "Ad zorunludur.",
              minLength: {
                value: 2,
                message: "En az 2 karakter giriniz.",
              },
            })}
          />
          {errors.firstName && <small>{errors.firstName.message}</small>}
        </label>

        <label>
          <span>Soyad</span>
          <input
            type="text"
            autoComplete="family-name"
            {...register("lastName", {
              required: "Soyad zorunludur.",
              minLength: {
                value: 2,
                message: "En az 2 karakter giriniz.",
              },
            })}
          />
          {errors.lastName && <small>{errors.lastName.message}</small>}
        </label>
      </div>

      <label>
        <span>E-posta</span>
        <input
          type="email"
          autoComplete="email"
          {...register("email", {
            required: "E-posta adresi zorunludur.",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Geçerli bir e-posta adresi giriniz.",
            },
          })}
        />
        {errors.email && <small>{errors.email.message}</small>}
      </label>

      <fieldset className="package-choice">
        <legend>Hangi paketi tercih edersiniz?</legend>
        <div className="package-options">
          {PACKAGE_OPTIONS.map((option) => (
            <label className="package-option" key={option.value}>
              <input
                type="radio"
                value={option.value}
                {...register("preferredPackage", {
                  required: "Lütfen bir paket seçiniz.",
                })}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
        {errors.preferredPackage && <small>{errors.preferredPackage.message}</small>}
      </fieldset>

      {submitError && <p className="form-submit-error">{submitError}</p>}

      <button type="submit" className="primary-btn form-submit" disabled={isSubmitting}>
        {isSubmitting ? "Gönderiliyor..." : buttonLabel}
      </button>
    </form>
  );
}

export default WaitlistForm;
